import { render, staticRenderFns } from "./popup-lottery.vue?vue&type=template&id=7c70f02e&scoped=true&"
import script from "./popup-lottery.vue?vue&type=script&lang=js&"
export * from "./popup-lottery.vue?vue&type=script&lang=js&"
import style0 from "./popup-lottery.vue?vue&type=style&index=0&id=7c70f02e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70f02e",
  null
  
)

export default component.exports